import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneValidation'
})

export class PhoneValidationPipe implements PipeTransform {
    transform(phoneNumber: string): boolean {
        // phoneNumber = phoneNumber?.replace(/ /g, "")?.replace(/\+/g, "")?.replace(/\-/g, "");
        return phoneNumber?.length > 50;
    }
}
